import { useNavigate } from 'react-router-dom';
import './ReportsListPage.css';
import { useAuth } from '../../../contexts/AuthContext';
import { ReactComponent as PlusIcon } from '../../../assets/icons/plus-icon.svg';
import { ReactComponent as ReportDocumentIcon } from '../../../assets/icons/report-document-icon.svg';
import { reportsService } from '../../../services/reportsService';
import { formatToReadableDate } from '../../../utils/utils';
import { useState, useEffect } from 'react';

export default function ReportsListPage() {
  const { fetchUserInfo } = useAuth();
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [isNewOpened, setIsNewOpened] = useState(false);
  const [newReportName, setNewReportName] = useState("");
  const navigate = useNavigate();
  const [reportList, setReportList] = useState([]);

  useEffect(() => {
    setIsLoadingData(true);
    reportsService.getReports()
      .then(reports => {
        if (reports?.length > 0) {
          setReportList(reports);
        }
      })
      .catch(error => {
        console.error("Error fetching reports: ", error);
      })
      .finally(() => {
        setIsLoadingData(false);
      });
      
  }, []);

  const handleNewReport = () => {
    setIsLoadingData(true);
    setIsNewOpened(false);
    reportsService.getNewReport()
      .then(async reportData => {
        console.log("getNewReport: ", reportData);      
        if(reportData){
            const newReport = {
              "report_name": newReportName ||reportData.report.report_name,
              "is_draft": true,
              "historical_table": reportData.report.historical_table,
              "forecast_table": reportData.report.forecast_adjustments
            };
            
            console.log("newReport: ", newReport);
            await reportsService.createReport(newReport)
              .then(newReportData => {
                if(newReportData?.report?.report_id){
                  fetchUserInfo();
                  navigate(`/reports/${newReportData.report.report_id}`);
                }
              })
              .catch(error => {
                console.error("Error fetching new report: ", error);
              })
        }
      })
      .catch(error => {
        console.error("Error fetching new report: ", error);
      })
      .finally(() => {
        setIsLoadingData(false);
      });

  }

  return (
    <div className="page-content">
      <div className="page-header-container">
        <h1>Отчет по планированию спроса</h1>
      </div>

      <div className="page-subheading-row">
        <span className="reports-list-text">
          Сформируйте новый отчет или посмотрите и вводите изменения в ранее сохраненные отчеты
        </span>
      </div>

      <div className="reports-list">
        {isLoadingData && 
            
          <div className="loading-overlay">
            <div style={{display: "flex",
                justifyContent: "center",
                alignItems: "center"}}>
                <div className="login-spinner"></div>
              </div>
          </div>

        }

        <div className="reports-list-item">
          <div className="reports-list-item-card" onClick={() => setIsNewOpened(true)}>
            <PlusIcon size={48} color="#7CC805"/>
          </div>
          <div className="reports-list-item-text">
            Создать новый отчет
          </div>
        </div>
        {
          reportList.map((report, index) => (
            <div key={index} className="reports-list-item">
              <div className="reports-list-item-card existing" onClick={() => navigate(`/reports/${report.report_id}`)}>
                <ReportDocumentIcon size={48} color="#7CC805"/>
              </div>
              <div className="reports-list-item-text">
                {report.report_name + " за " + formatToReadableDate(report.planning_month)}
              </div>
            </div>
          )) 
        }
      </div>
      
      {
        isNewOpened && 
          <div className="modal-overlay" onClick={() => setIsNewOpened(false)}>
              <div className="modal-container" style={{ minWidth: "320px", maxWidth: "520px" }} onClick={(e) => e.stopPropagation()}>
                 
                  <div className='modal-body' style={{justifyContent: "center", gap: "20px", alignItems: "center"}}>

                      <div className="form-group" style={{ width: "100%", marginBottom: "0px"}}>
                        <label htmlFor="orderId" style={{ fontSize: 16, fontWeight: 500 }} className="form-label">
                          Название отчета
                        </label>

                        <div className={`form-input`} style={{ padding: "8px 16px", display: 'flex', justifyContent: "space-between", alignItems: 'center', alignContent: "center" }}>
                          <input
                              type="text"
                              style={{ border: "0px", flex: 1, outline: "none", fontSize: 16, backgroundColor: "#ffffff" }}
                              value={newReportName ?? ""}
                              // placeholder='Введите название'
                              onChange={(e) => {
                                setNewReportName(e.target.value);
                              }}
                          />
                        </div>
                      </div>
                      <div style={{display: 'flex', width: "100%", justifyContent: "space-between", gap: "16px", flexDirection: "row"}}>                          
                          <button
                              onClick={() => handleNewReport()}
                              style={{flex: 1}}
                              type="button" className="primary-button"
                          >
                              Создать
                          </button>
                          <button
                              onClick={() => setIsNewOpened(false)}
                              style={{flex: 1}}
                              type="button" className="cancel-button"
                          >
                              Отмена
                          </button>
                      </div>

                  </div>

              </div>
          </div>
      }
    </div>
  );
}